module.exports = __webpack_public_path__ + "static/987130374-wide.cf53b966.jpg";